import { Fragment, forwardRef } from "react"

import { ALink, Spinner } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

import { PaymentMethods } from "../../payment-methods"

import { usePrimaryPaymentMethodHook } from "./use-primary-payment-method.hook"
import withOrderSummary from "./with-order-summary"
import withServerActions from "./with-server-actions"
import withTokenization from "./with-tokenization"

const PaymentMethodsWithActions = withServerActions(PaymentMethods)

const PaymentMethodsDetails = forwardRef(
  (
    { order, hideHeader, hidePaymentMethods, onTokenization, className },
    ref
  ) => {
    const { primaryPaymentMethod, isFetchingPrimaryPaymentMethod } =
      usePrimaryPaymentMethodHook()

    if (isFetchingPrimaryPaymentMethod) {
      return (
        <div
          sx={{
            textAlign: "center",
          }}
        >
          <Spinner />
        </div>
      )
    }

    return (
      <div ref={ref} className={className} data-component-name="PaymentMethods">
        {hideHeader ? null : (
          <Fragment>
            <div
              sx={{
                mt: 7,
                mb: 4,
                fontSize: 4,
                variant: "vwo.heading",
              }}
            >
              <Trans i18nKey="Payment.Methods.title" />
            </div>
          </Fragment>
        )}

        <PaymentMethodsWithActions
          order={order}
          primaryPaymentMethod={primaryPaymentMethod}
          hidePaymentMethods={hidePaymentMethods}
          onTokenization={onTokenization}
        />

        <div sx={{ mt: 4, fontSize: 1, color: "textDark" }}>
          <Trans
            i18nKey="Payment.Methods.moneyBackMessage"
            sx={{ color: "text" }}
          >
            <span sx={{ color: "text" }} />
            <ALink
              isUnderlined
              href="https://support.formelskin.de/hc/de/articles/360022115719-Gibt-es-eine-Geld-zur%C3%BCck-Garantie-und-wie-funktioniert-sie-"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "inherit" }}
            />
          </Trans>
        </div>
      </div>
    )
  }
)

export const Methods = withOrderSummary(PaymentMethodsDetails)

export const MethodsTokenization = withTokenization(PaymentMethodsDetails)
